import type {ListenerEffectAPI} from "@reduxjs/toolkit";

import chapterCompleted from "./chapterCompleted";
import {keyProvider} from "../keyProvider";
import {CompletionStatus} from "../outcomes/ExerciseOutcomes";
import selectAllChapterOutcomes from "../outcomes/selectAllChapterOutcomes";
import selectChapterContentStats from "./selectChapterContentStats";
import type {AppDispatch, RootState} from "../store";
import submitStudentResponse from "../studentResponses/submitStudentResponse";

function listener(
	action: ReturnType<typeof submitStudentResponse.fulfilled>,
	api: ListenerEffectAPI<RootState, AppDispatch>
) {
	const state = api.getState();
	const chapterKey = keyProvider.chapter(action.meta.arg.chapterId);

	const [outcomes] = selectAllChapterOutcomes(state, chapterKey);

	const [nonTheoryExercisesCount] = selectChapterContentStats(
		state,
		chapterKey
	);

	const numberOfCompleted = outcomes.reduce(
		(n, o) => (o.completionStatus === CompletionStatus.Complete ? ++n : n),
		0
	);

	if (numberOfCompleted === nonTheoryExercisesCount) {
		api.dispatch(chapterCompleted({chapterKey}));
	}
}

export default listener;
